/** Billing-cadence definitions and matching. */

import type { CadenceName } from '../types';

export const DAY = 24 * 60 * 60 * 1000;

export interface Cadence {
  name: CadenceName;
  days: number;
  min: number;
  max: number;
  perMonth: number;
}

export const CADENCES: Cadence[] = [
  { name: 'weekly',     days: 7,      min: 5.5, max: 8.5,  perMonth: 4.348 },
  { name: 'biweekly',   days: 14,     min: 12,  max: 16,   perMonth: 2.174 },
  { name: 'monthly',    days: 30.44,  min: 26,  max: 35,   perMonth: 1 },
  { name: 'quarterly',  days: 91.3,   min: 80,  max: 100,  perMonth: 1 / 3 },
  { name: 'semiannual', days: 182.6,  min: 165, max: 200,  perMonth: 1 / 6 },
  { name: 'yearly',     days: 365.25, min: 330, max: 400,  perMonth: 1 / 12 },
];

export const CADENCE_LABEL: Record<CadenceName, string> = {
  weekly: 'Weekly',
  biweekly: 'Every 2 weeks',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  semiannual: 'Every 6 months',
  yearly: 'Yearly',
};

export function matchCadence(gapDays: number): Cadence | null {
  return CADENCES.find((c) => gapDays >= c.min && gapDays <= c.max) ?? null;
}

export function median(nums: number[]): number {
  const s = [...nums].sort((a, b) => a - b);
  const mid = Math.floor(s.length / 2);
  return s.length % 2 ? s[mid]! : (s[mid - 1]! + s[mid]!) / 2;
}
